import Validator from '@shared/validatorjs/src/validator'
import { UpdateSettingsRequest, UpdateField } from './../settings.actions'
import { FetchDataCyclesRequest } from './../../data-cycles/data-cycles.actions'
import { getDataCyclesState } from './../../data-cycles/data-cycles.selectors'
import { getFormsState } from './../../forms/forms.selectors'
import FormTrait from 'src/app/traits/form.trait'
import { getSettingsState } from './../settings.selectors'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { getRoundFactorsState } from '@shared/shared.select'
import { FetchRoundFactorsRequest } from '@shared/shared.actions'
import { select, Store } from '@ngrx/store'
import { Map } from 'immutable'

@Component({
  selector: 'app-general-settings',
  templateUrl: './general-settings.component.html',
  styleUrls: ['./general-settings.component.css'],
})
export class GeneralSettingsComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  public forms: []
  public dataCycles: []
  public roundFactors: []
  private dataCyclesState$: Subscription
  private roundFactorsState$: Subscription
  private state$: Subscription
  private formsState$: Subscription
  public isLoading: boolean

  constructor(public store: Store<any>) {
    super()
  }

  ngOnInit() {
    this.state$ = this.store
      .pipe(select(getSettingsState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })

    this.formsState$ = this.store
      .pipe(select(getFormsState))
      .subscribe((state) => {
        this.forms = state.get('data').toJS()
      })

    this.dataCyclesState$ = this.store
      .pipe(select(getDataCyclesState))
      .subscribe((state) => {
        this.dataCycles = state.get('data').toJS()
      })

    this.roundFactorsState$ = this.store
      .pipe(select(getRoundFactorsState))
      .subscribe((state) => {
        this.roundFactors = state
      })

    this.store.dispatch<any>(new FetchRoundFactorsRequest())
    this.store.dispatch<any>(
      new FetchDataCyclesRequest({
        pageSize: 500,
      }),
    )
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.formsState$.unsubscribe()
    this.dataCyclesState$.unsubscribe()
    this.roundFactorsState$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(name || e.target.name, name ? e : e.target.value, 'data'),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        '',
      ),
    )
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      currentDataCycleId: 'required',
      roundFactor: 'required',
      clientBaseUrl: 'required',
    }
    const validator = new Validator(data.toJS(), rules)

    validator.setAttributeNames({
      currentDataCycleId: 'current data cycle',
      roundFactor: 'round factor',
      clientBaseUrl: 'client base url',
    })

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()

    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(new UpdateSettingsRequest(payload))
    } else {
      this.store.dispatch<any>(
        new UpdateField('validationErrors', validation.errors.errors, ''),
      )
    }
  }
}
